import { render, staticRenderFns } from "./UserRecords.vue?vue&type=template&id=011aca50&scoped=true&"
import script from "./UserRecords.vue?vue&type=script&lang=js&"
export * from "./UserRecords.vue?vue&type=script&lang=js&"
import style0 from "./UserRecords.vue?vue&type=style&index=0&id=011aca50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011aca50",
  null
  
)

export default component.exports